import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, DialogContentText } from "@mui/material";
import { Col, Row } from "reactstrap";
import moment from "moment";

import { getOptionLabel } from "common/enums";

import { useGetBillingCycleByIdQuery } from "apis/BillingCycle";

import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";

export const BillingCycleViewModal = ({ selectedBillCycleId, t }) => {
  const { data: { data: billingCycleData } = {}, isLoading } =
    useGetBillingCycleByIdQuery(selectedBillCycleId);

  if (isLoading) {
    return (
      <div className="w-100 text-center mt-3">
        <CircularProgress />
      </div>
    );
  }

  return (
    <DialogContentText variant="subtitle2" component="div">
      <Row className="mt-2">
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Subscription Type")} :</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.subscriptionType
                ? getOptionLabel(
                    "subscriptionTypes",
                    billingCycleData.subscriptionType
                  )
                : "-"}
            </Col>
          </Row>
        </Col>
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Bill Group")}:</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.billGroup ?? "-"}
            </Col>
          </Row>
        </Col>
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Bill Cycle")} :</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.billCycle &&
              moment(billingCycleData.billCycle).isValid()
                ? convertUTCDateToLocalDate(billingCycleData.billCycle).format(
                    "MMM-YYYY"
                  )
                : "-"}
            </Col>
          </Row>
        </Col>
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Status")} :</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.status
                ? getOptionLabel("billingStatus", billingCycleData.status)
                : "-"}
            </Col>
          </Row>
        </Col>
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Charge Start Date")} :</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.chargeStartDate &&
              moment(billingCycleData.chargeStartDate).isValid()
                ? convertUTCDateToLocalDate(
                    billingCycleData.chargeStartDate
                  ).format("DD-MM-YYYY")
                : "-"}
            </Col>
          </Row>
        </Col>
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Charge End Date")} :</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.chargeEndDate &&
              moment(billingCycleData.chargeEndDate).isValid()
                ? convertUTCDateToLocalDate(
                    billingCycleData.chargeEndDate
                  ).format("DD-MM-YYYY")
                : "-"}
            </Col>
          </Row>
        </Col>
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Validation Date")} :</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.validationDate &&
              moment(billingCycleData.validationDate).isValid()
                ? convertUTCDateToLocalDate(
                    billingCycleData.validationDate
                  ).format("DD-MM-YYYY")
                : "-"}
            </Col>
          </Row>
        </Col>
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Bill Date")} :</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.billDate &&
              moment(billingCycleData.billDate).isValid()
                ? convertUTCDateToLocalDate(billingCycleData.billDate).format(
                    "DD-MM-YYYY"
                  )
                : "-"}
            </Col>
          </Row>
        </Col>
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Payment Due Date")}:</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.paymentDueDate &&
              moment(billingCycleData.paymentDueDate).isValid()
                ? convertUTCDateToLocalDate(
                    billingCycleData.paymentDueDate
                  ).format("DD-MM-YYYY")
                : "-"}
            </Col>
          </Row>
        </Col>
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Payment Grace Date")}:</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.paymentGraceDate &&
              moment(billingCycleData.paymentGraceDate).isValid()
                ? convertUTCDateToLocalDate(
                    billingCycleData.paymentGraceDate
                  ).format("DD-MM-YYYY")
                : "-"}
            </Col>
          </Row>
        </Col>
        <Col lg={6} className="mb-2">
          <Row>
            <Col md={5}>{t("Reason")}:</Col>
            <Col md={7} className="fw-semibold">
              {billingCycleData?.reason || "N/A"}
            </Col>
          </Row>
        </Col>
      </Row>
    </DialogContentText>
  );
};

BillingCycleViewModal.propTypes = {
  selectedBillCycleId: PropTypes.number,
  t: PropTypes.func,
};

export default BillingCycleViewModal;
